import React, { useEffect, useState } from "react";
import { Paper, Grid } from "@material-ui/core"
import { ModalAlcohol } from "./component/modalAlcohol";
import { ListBasculaAlcohol } from "./component/listBasculaAlcohol";
import MigaPan from "../../app/orussystem/component/MigaPan";
import { panelAlcoholStyle } from "./panelAlcoholStyle";


export const PanelAlcoholimetria = () => {

    const [isOpenModal, setIsOpenModal] = useState(false)
    const [basculas] = useState([])
    const [dataSelect, setDataSelect] = useState({})
    const classes = panelAlcoholStyle();

    const openModalData = (data) => {
        setDataSelect(data)
        setIsOpenModal(true)
    }


    useEffect(async () => {
       
    }, [])


    return (
        <>
            {isOpenModal && <ModalAlcohol
                setopenMondal={setIsOpenModal}
                isOpen={isOpenModal}
                data={dataSelect}
            />}
            <Grid item xs={12} >
                <br></br>
                <br></br>

                <MigaPan
                    namePage={`Alcoholimetro`}
                    to="/"
                >
                    Home
                </MigaPan>
            </Grid>
            <Grid item xs={5} style={{ textAlign: "left" }}>
             
            </Grid>

            <Grid item xs={12}>
                <Paper className={classes.paper}>
                    <ListBasculaAlcohol
                        rows={basculas}
                        openModal={openModalData}
                        classes={classes}
                        isLoadUser={false}
                        page={0}
                        size={0}
                        totalElement={0}
                        setPage={() => { }}

                    />
                </Paper>
            </Grid>
        </>
    );
}